
<img src="assets/images/icons/info.svg" class="generic-confirm__header__icon" alt="info">

<p class="generic-confirm__msg">{{ title }}</p>

<p *ngIf="info" class="generic-confirm__strong">{{ info }}</p>

<footer class="generic-confirm__actions">
    <button mat-stroked-button color="warn" (click)="close(false)" class="generic-confirm__actions__button">{{ cancel }}</button>
    <button mat-flat-button color="warn" (click)="close(true)" class="generic-confirm__actions__button">{{ confirm }}</button>
</footer>
